export const ERROR_CODE = {
  INVALID_CREDENTIAL_CODE: -3,
  INVALID_OTP_CODE: -4,
  ACCOUNT_LOCKED_CODE: -5,
  ACCOUNT_LOCKED_CODE_TEMPORARILY: -1,
  INVALID_PASSWORD_FORMAT_CODE: -6,
  REACH_MAX_FAIL_ATTEMPTS_CODE: -7,
  REPEATED_PASSWORD_CODE: -8,
  INVALID_PASSWORD_UPDATE_CODE: -9,
  UNHANDLED_ERROR_FROM_PING_FEDERATE_CODE: -10,
  NO_DEVICE_FOUND_CODE: -11,
  MUST_CHANGE_PASSWORD: -12,
  MFA_SETUP_REQUIRED: -13
};
